import { render, staticRenderFns } from "./BlockDocuments.vue?vue&type=template&id=3e52499d"
import script from "./BlockDocuments.vue?vue&type=script&lang=js"
export * from "./BlockDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports